import { ColumnsType } from 'antd/es/table';
//
import {
  Col,
  Row,
  Table,
  Divider,
  Modal,
  Form,
  Input,
  Collapse,
  Select,
  Result,
  Popover,
  Slider,
  Space,
  Spin,
  Tag,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import { useFormik } from 'formik';
import { MainLayout } from 'components';
import Button from 'components/Button';
import { useEffect, useRef, useState } from 'react';
import pageTitleStore from 'store/pageTitleStore';
import {
  AlertBlue,
  CategoryCancel,
  FilterGoldIcon,
  FilterIcon,
  SendApproval,
  ValidateFail,
  ValidateSuccess,
} from 'assets/svg';
import { useMutation, useQuery } from 'react-query';
import CapitalApi from 'apis/CapitalApi';
import AllocateApi from 'apis/AllocateApi';
import {
  CloseOutlined,
  DownOutlined,
  DownloadOutlined,
  UpOutlined,
} from '@ant-design/icons';
import type { CollapseProps } from 'antd';
import CartApi from 'apis/CartApi';
import { openNotificationWithIcon } from 'utils/notification';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useUser } from 'contexts/User';
import useQueryParam from 'hooks/useQueryPrams';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import ProductCartInfo from 'components/Modules/Cart/CartTVV/ProductCartInfo';
import { HocChangePagination } from 'utils/HocChangePagination';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import ProductApi from 'apis/ProductApi';
import { useForm } from 'antd/es/form/Form';
import { PageTitle } from 'constants/title';
import CartProductItem from 'components/Modules/Cart/CartProductItem';
import * as XLSX from 'xlsx';
import formatNumber from 'utils/formatNumber';
import { headerOrderReg } from 'constants/exportOrderReg';

type FixedType = 'left' | 'right' | boolean;
const { TextArea } = Input;

export default function ChtView() {
  document.title = PageTitle;

  const { user } = useUser();

  const isRoleBranch =
    user?.role.includes('cua_hang_truong') ||
    user?.role.includes('nguoi_dat_hang') ||
    user?.plantCode == 1000
      ? false
      : true;

  const location = useLocation<{
    cart?: any;
    cartOrderBranchId?: any;
    isViewDetailAllBranch?: any;
    isExportAsTVV?: boolean;
  }>();
  const { state } = location;

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  const history = useHistory();

  const [searchName, setSearchName] = useState<any>();
  const [nhanhangSelected, setNhanHang] = useState<any>([]);
  const [donghangSelected, setDongHang] = useState<any>([]);
  const [nganhhangSelected, setNganhHang] = useState<any>([]);
  const [chungloaiSelected, setChungLoai] = useState<any>([]);
  const [isBoCap, setBoCap] = useState<any>();
  const [formSubmitParams, setFormSubmitParams] = useState<any>();
  const [bstSelected, setBST] = useState<any>();

  const [isOpenFilterAdvanced, setIsOpenFilterAdvanced] =
    useState<boolean>(false);
  const toggleFilterAdvanced = () => {
    setIsOpenFilterAdvanced(!isOpenFilterAdvanced);
  };

  const { Option } = Select;
  const [form] = useForm();

  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalConfirmDelALL, setModalConfirmDelALL] = useState<boolean>(false);
  const [modalConfirmDelete, setModalConfirmDelete] = useState<boolean>(false);
  const [modalConfirmReject, setModalConfirmReject] = useState<boolean>(false);
  const [modalData, setModalData] = useState<any>(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalRejectOpen, setModalRejectOpen] = useState<boolean>(false);
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const [total, setTotal] = useState<number>();
  const [cartOrderCHT, setCartOrderCHT] = useState<any[]>([]);
  const [TvvReject, setTvvReject] = useState<any[]>();
  const [nameTVVrejected, setNameTVVrejected] = useState<string>();

  const [dataValidate, setDataValidate] = useState<any[]>();
  const [minRegister, setMinRegister] = useState<any>();
  const [maxRegister, setMaxRegister] = useState<any>();
  const [minQuantity, setMinQuantity] = useState<any>();
  const [maxQuantity, setMaxQuantity] = useState<any>();
  const [dataCapital, setDataCapital] = useState<any[]>();
  const [dataDongHang, setDataDongHang] = useState<any[]>();
  const [dataProductPof, setDataProductPof] = useState<any[]>();
  const [capitalInfo, setCapitalInfo] = useState<any>();
  const [capitalYear, setCapitalYear] = useState<number | null>(null);
  const [isCapitalYearLoaded, setIsCapitalYearLoaded] = useState(false);
  const [validateLoading, setValidateLoading] = useState<boolean>(false);
  const [cart_register_detail, setCart_register_detail] = useState<any>();
  const [dataDelete, setDataDelete] = useState<{
    cart_order_cht_id: number;
    list_cart_order_cht_dt_ids: [any];
  }>();
  const [disableBtnCss, setDisableBtnCss] = useState<string>('bg-primary-50');
  const modalRef = useRef();

  const { cart_order_cht_id, list_cart_order_cht_dt_ids } = { ...dataDelete };

  interface Iparam {
    id: string;
  }
  const { id } = useParams<Iparam>();
  const cart_register_id = parseInt(id);

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;
  const pagination = { page: page, page_size: page_size };

  useEffect(() => {
    const branchCodeRaw = user?.branch_code ?? user?.plantCode;
    const branchCode =
      branchCodeRaw !== undefined && branchCodeRaw !== null
        ? String(branchCodeRaw)
        : undefined;

    if (!branchCode) {
      const currentYear = new Date().getFullYear();
      setCapitalYear(currentYear);
      setIsCapitalYearLoaded(true);
      return;
    }

    const fetchMaxCapitalYear = async () => {
      try {
        const response = await AllocateApi.getMaxCapitalYear(branchCode);
        const maxCapitalYear =
          response?.data?.data?.max_capital_year ??
          response?.data?.max_capital_year;

        if (maxCapitalYear !== undefined && maxCapitalYear !== null) {
          const parsedYear = Number(maxCapitalYear);
          if (!Number.isNaN(parsedYear)) {
            setCapitalYear(parsedYear);
            return;
          }
        }
        setCapitalYear(new Date().getFullYear());
      } catch (error) {
        setCapitalYear(new Date().getFullYear());
      } finally {
        setIsCapitalYearLoaded(true);
      }
    };

    fetchMaxCapitalYear();
  }, [user?.branch_code, user?.plantCode]);

  const { data } = useQuery(['getTvv', user?.plantId, cart_register_id], () => {
    CartApi.getTvvToReject(user?.plantId, cart_register_id)
      .then((res) => {
        setTvvReject(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  });

  const { data: cartAllocatedd, isLoading: getIdLoading } = useQuery(
    ['get'],
    () => CartApi.getCartAllocated()
  );

  const cart_name = (cartAllocatedd?.data || []).filter((item: any) => {
    return item?.cart_register_id === cart_register_id;
  });

  const convertStatus = (status: number) => {
    switch (status) {
      case undefined:
      case null:
      case 0:
        return 'Mới tạo';
      case 1:
        return 'CHT duyệt và gửi CN';
      case 2:
        return 'CN duyệt';
      case 3:
        return 'CN từ Chối';
      case 4:
        return 'HS duyệt';
      case 5:
        return 'HS từ chối';
      default:
        return '-';
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      cart_order_tvv_id: '',
      cart_order_cht_id: cartOrderCHT[0]?.cart_order_cht_id,
      reject_description: '',
    },
    onSubmit(values) {
      const newValues = {
        ...values,
      };
      const tvvName = TvvReject?.filter(
        (item) => item?.cart_ordert_tvv_id === newValues?.cart_order_tvv_id
      );
      setNameTVVrejected((tvvName || [])[0]?.full_name);
      CartApi.rejectCartTvv(newValues)
        .then((res) => {
          setModalConfirmReject(true);
          setModalRejectOpen(false);
          refetch();
        })
        .catch((err) => {
          setModalRejectOpen(false);
          openNotificationWithIcon('error', err.toString());
        });
    },
  });

  const handleChangeSelect = (name: string) => {
    return (value: any) => {
      formik.setFieldValue(name, value);
    };
  };
  const requestApprovalToBranch = () => {
    if (!isCapitalYearLoaded || capitalYear === null) {
      openNotificationWithIcon('warning', 'Vui lòng chờ tải năm vốn');
      return;
    }
    setModalOpen(false);
    setValidateLoading(true);
    CartApi.requestApprovalToBranch(
      cartOrderCHT[0].cart_order_cht_id,
      capitalYear ?? undefined
    )
      .then((res) => {
        setValidateLoading(false);
        openNotificationWithIcon('success', 'Gửi yêu cầu thành công');
        history.push('/product-register');
      })
      .catch((err) => {
        setValidateLoading(false);
        openNotificationWithIcon('error', err.toString());
      });
  };
  const { isLoading: capitalInfoLoading } = useQuery(
    ['getCapitalShop', user?.plantId, capitalYear],
    () =>
      CapitalApi.getCapitalShop(
        user?.plantId,
        capitalYear ?? new Date().getFullYear()
      )
        .then((res) => {
          setCapitalInfo(res);
          setDataCapital(res.data?.product_capital_info);
          setDataProductPof(res.data?.product_capital_pof_info);
        })
        .catch((err) => {
          console.log(err);
        }),
    {
      enabled: isCapitalYearLoaded && !!user?.plantId,
    }
  );
  function ChangeValueMax(event: any, record: any) {
    updateProductInfo(record, undefined, parseInt(event.target.value));
  }

  function ChangeValueMin(event: any, record: any) {
    updateProductInfo(record, parseInt(event.target.value), undefined);
  }

  function updateProductInfo(record: any, min?: number, max?: number) {
    const params = {
      id: record.cart_order_cht_dt_id,
      order_min: min ?? record.order_min,
      order_max: max ?? record.order_max,
      list_order_size: [],
    };

    if (params.order_max < params.order_min) {
      openNotificationWithIcon('error', 'Max phải lớn hơn hoặc bằng Min');
      const updatedList = cartOrderCHT.map((product) => {
        if (
          product.cart_register_detail_id === record.cart_register_detail_id
        ) {
          return {
            ...product,
            order_min: min ?? record.order_min,
            order_max: max ?? record.order_max,
          };
        }
        return product;
      });
      setCartOrderCHT(updatedList);
    } else {
      CartApi.updateProductCHT(params)
        .then((res) => {
          openNotificationWithIcon('success', 'Cập nhật thành công');
          const updatedList = cartOrderCHT.map((product) => {
            if (
              product.cart_register_detail_id === record.cart_register_detail_id
            ) {
              return {
                ...product,
                order_min: min ?? record.order_min,
                order_max: max ?? record.order_max,
              };
            }
            return product;
          });
          setCartOrderCHT(updatedList);
        })
        .catch((err) => {
          openNotificationWithIcon('error', err.toString());
        });
    }
  }

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = (values: any) => {
    const filteredData = Object.fromEntries(
      Object.entries(values).filter(
        ([_, value]) =>
          value !== undefined && !(Array.isArray(value) && value.length === 0)
      )
    );
    const stringifiedData: { [key: string]: any } = {};
    Object.keys(filteredData).forEach((key) => {
      if (
        key == 'plhh' ||
        key == 'dong_hang' ||
        key == 'nganh_hang' ||
        key == 'chung_loai' ||
        key == 'loai_da' ||
        key == 'nhom_da' ||
        key == 'line_xman' ||
        key == 'material_type' ||
        key == 'kldg_3tc'
      ) {
        stringifiedData[key] = filteredData[key];
      } else if (key == 'cost_price') {
        const values: any = filteredData[key];
        stringifiedData['min_cost_price'] = values[0];
        stringifiedData['max_cost_price'] = values[1];
      } else if (key == 'price') {
        const values: any = filteredData[key];
        stringifiedData['min_price'] = values[0];
        stringifiedData['max_price'] = values[1];
      } else {
        stringifiedData[key] = String(filteredData[key]);
      }
    });
    console.log('stringifiedData', stringifiedData);
    setFormSubmitParams(stringifiedData);
    history.push(`/order/cht-view/${id}`, {
      page: 1,
      page_size: page_size,
    });
  };

  const handleReset = () => {
    form.resetFields();
    setFormSubmitParams(undefined);
  };

  const params = {
    page: page.toString(),
    page_size: page_size.toString(),
    shop_id: user?.plantId,
    ...(user?.role.includes('cua_hang_truong')
      ? { cart_register_id: cart_register_id }
      : { cart_order_cht_id: cart_register_id }),
    ...(searchName && { ten_mau: searchName }),
    ...(nhanhangSelected &&
      nhanhangSelected.length != 0 && { nhan_hang: nhanhangSelected }),
    ...(donghangSelected &&
      donghangSelected.length != 0 && { dong_hang: donghangSelected }),
    ...(nganhhangSelected &&
      nganhhangSelected.length != 0 && { nganh_hang: nganhhangSelected }),
    ...(chungloaiSelected &&
      chungloaiSelected.length != 0 && { chung_loai: chungloaiSelected }),
    ...(isBoCap && isBoCap == 'is_group_bo' && { is_group_bo: true }),
    ...(isBoCap && isBoCap == 'is_group_cap' && { is_group_cap: true }),
    ...(bstSelected && { bst: bstSelected }),
    ...(formSubmitParams && formSubmitParams),
  };

  const paramsBranch = {
    page: page.toString(),
    page_size: page_size.toString(),
    branch_id: user?.plantId,
    cart_register_id,
    cart_order_branch_id: state?.cartOrderBranchId,
    // ...(searchName && { ten_mau: searchName }),
    // ...(nhanhangSelected &&
    //   nhanhangSelected.length != 0 && { nhan_hang: nhanhangSelected }),
    // ...(donghangSelected &&
    //   donghangSelected.length != 0 && { dong_hang: donghangSelected }),
    // ...(nganhhangSelected &&
    //   nganhhangSelected.length != 0 && { nganh_hang: nganhhangSelected }),
    // ...(chungloaiSelected &&
    //   chungloaiSelected.length != 0 && { chung_loai: chungloaiSelected }),
  };

  const { mutate: refetch, isLoading: getCartOrderCHT } = useMutation(
    () =>
      isRoleBranch && state?.isViewDetailAllBranch
        ? CartApi.getCartOrderAllBranch(paramsBranch)
        : CartApi.getCartCHT_view(params),

    {
      onSuccess: (res: any) => {
        setCartOrderCHT(res.data);
        setTotal(res.total);
        setMinRegister(res.sum_min_cost_price);
        setMaxRegister(res.sum_max_cost_price);
        setMinQuantity(res.sum_order_min);
        setMaxQuantity(res.sum_order_max);
        setDataDongHang(res?.data_dong_hang);
      },
      onError: (e: any) => {
        openNotificationWithIcon('error', e);
      },
    }
  );

  const { data: lstProductOption } = useQuery(
    ['getProductOption'],
    () => ProductApi.getProductOption() // lấy ds option
  );

  const pthh_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'plhh'
  );
  const plhh =
    pthh_list == undefined || pthh_list.length == 0 ? [] : pthh_list[0]['list'];

  const donghang = lstProductOption?.data?.filter(
    (option: any) => option.type === 'line_xman'
  )[0]['list'];

  const nganhhang = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nganhhang'
  )[0]['list'];

  const chungloai = lstProductOption?.data?.filter(
    (option: any) => option.type === 'chungloai'
  )[0]['list'];

  const bst = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bst'
  )[0]['list'];

  const phankhuc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'phankhuc'
  )[0]['list'];

  const costprice = lstProductOption?.data?.filter(
    (option: any) => option.type === 'cost_price'
  )[0]['data'];

  const price = lstProductOption?.data?.filter(
    (option: any) => option.type === 'price'
  )[0]['data'];

  const loaida = lstProductOption?.data?.filter(
    (option: any) => option.type === 'loai_da'
  )[0]['list'];

  const nhomda = lstProductOption?.data?.filter(
    (option: any) => option.type === 'nhom_da'
  )[0]['list'];

  const donghangsap = lstProductOption?.data?.filter(
    (option: any) => option.type === 'donghang'
  )[0]['list'];

  const gioitinh = lstProductOption?.data?.filter(
    (option: any) => option.type === 'gioitinh'
  )[0]['list'];

  const bo = lstProductOption?.data?.filter(
    (option: any) => option.type === 'bo'
  )[0]['list'];

  const cap = lstProductOption?.data?.filter(
    (option: any) => option.type === 'cap'
  )[0]['list'];

  const xman = lstProductOption?.data?.filter(
    (option: any) => option.type === 'xman'
  )[0]['list'];

  const kldg_3tc = lstProductOption?.data?.filter(
    (option: any) => option.type === 'kldg_3tc'
  )[0]['list'];

  const materialtype_list = lstProductOption?.data?.filter(
    (option: any) => option.type === 'material_type'
  );

  const materialtype =
    materialtype_list == undefined || materialtype_list.length == 0
      ? []
      : materialtype_list[0]['list'];

  const deleteProdctCHT = (
    id: number,
    listId: number[],
    is_delete_all: boolean
  ) => {
    CartApi.deleteCartCHT(id, listId, is_delete_all)
      .then((res) => {
        openNotificationWithIcon('success', 'Xoá thành công');
        refetch();
      })
      .catch((err) => {
        openNotificationWithIcon('error', err.toString());
      });
  };
  const CheckValidate = (id: any) => {
    setValidateLoading(true);
    CartApi.checkValidateCHT(id)
      .then((res) => {
        if (res.data === 'success') {
          setDataValidate([{ type: '', message: '' }]);
        } else {
          setDataValidate(res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setValidateLoading(false);
      });
  };

  const deleteAll = () => {
    if (cartOrderCHT.length <= 1 && cartOrderCHT[0] !== null) {
      openNotificationWithIcon('error', 'Không có sản phẩm để xoá');
    } else {
      deleteProdctCHT(cartOrderCHT[0]?.cart_order_cht_id, [], true);
    }
  };

  const showModal = (data: any) => {
    modalRef?.current?.setData(data);
    if (data) {
      setCart_register_detail(data);
    }
  };

  useEffect(() => {
    setTitle(
      `${cart_name[0]?.cart_name ?? state?.cart?.cart?.cart_name ?? '_'}`
    );
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="">Giỏ hàng</a>{' '}
          </p>
        ),
      },
      {
        title: (
          <p>
            <a href="/product-register">Đặt hàng</a>
          </p>
        ),
      },
      { title: <a>{cart_name[0]?.cart_name}</a> },
    ]);

    checkStatusCHT();
  }, [id, user, cart_name]);

  useEffect(() => {
    refetch();
  }, [
    user?.plantId,
    page,
    page_size,
    searchName,
    formSubmitParams,
    nhanhangSelected,
    donghangSelected,
    nganhhangSelected,
    chungloaiSelected,
    isBoCap,
    bstSelected,
  ]);

  const renderProductQuantityMax = () => {
    const max = maxQuantity;

    if ((dataValidate || [])?.length > 0) {
      const dataCheck = dataValidate?.find((item) => {
        return item.type === 'max-register';
      });
      if (dataCheck === undefined) {
        return (
          <span className="flex items-center gap-1">
            {max || 0} <ValidateSuccess />
          </span>
        );
      } else
        return (
          <span className="flex items-center gap-1">
            {max || 0}{' '}
            <Popover
              content={<div className="font-bold">{dataCheck.message}</div>}
            >
              <ValidateFail />
            </Popover>
          </span>
        );
    } else return <span>{max || 0}</span>;
  };
  const renderProductQuantityMin = () => {
    const min = minQuantity;

    if ((dataValidate || [])?.length > 0) {
      const dataCheck = dataValidate?.find((item) => {
        return item.type === 'min-register';
      });
      if (dataCheck === undefined) {
        return (
          <span className="flex items-center gap-1">
            {min || 0} <ValidateSuccess />
          </span>
        );
      } else
        return (
          <span className="flex items-center gap-1">
            {min || 0}{' '}
            <Popover
              content={<div className="font-bold">{dataCheck.message}</div>}
            >
              <ValidateFail />
            </Popover>
          </span>
        );
    } else return <span>{min || 0}</span>;
  };
  const renderValidateSet = (pof_code: string) => {
    const result = dataValidate?.filter((item) => {
      return item.product_code?.includes(pof_code);
    });

    if (result?.length === 0) {
      return '';
    } else {
      if ((result || [])[0]?.type === 'bo') {
        return (
          <>
            <p className="flex items-center gap-2 mt-4 font-bold">
              <ValidateFail /> Điều kiện đặt hàng chưa đúng:{' '}
              <span className="text-red-500">{(result || [])[0]?.message}</span>{' '}
            </p>

            <Row style={{ fontWeight: 'bold' }}>
              <Col span={4}>Các mã sản phẩm trong bộ:</Col>
              <Col>
                {(result || [])[0]?.product_code_full_list.map(
                  (item: any, index: any) => (
                    <Row className="text-primary-50" key={index}>
                      {item}
                    </Row>
                  )
                )}
              </Col>
            </Row>
          </>
        );
      }
      if ((result || [])[0]?.type === 'cap') {
        return (
          <>
            <p className="flex items-center gap-2 mt-4">
              <ValidateFail /> Điều kiện đặt hàng chưa đúng:{' '}
              <span className="text-red-500">{(result || [])[0]?.message}</span>{' '}
            </p>

            <p className="flex items-center gap-2 font-bold">
              <span>Các mã sản phẩm trong cặp:</span>
              {(result || [])[0]?.product_code_full_list.map((item: any) => (
                <Row key={item}>{item}</Row>
              ))}
            </p>
          </>
        );
      }
    }
  };
  const checkSetValidate = (pof_code: string) => {
    return dataValidate?.filter((item) => {
      return item.product_code?.includes(pof_code);
    });
  };
  const getCabinetCapital = (dong_hang: string) => {
    return dataCapital?.find((item: any) => item.dong_hang === dong_hang)
      ?.total_cabinet;
  };
  const renderValidateCapital = (item: any) => {
    if (dataValidate === undefined) {
      return (
        <Row>
          <Col className="text-sm text-neutral-50" span={6}>
            {item?.dong_hang || '-'}
          </Col>
          <Col span={18} className="text-sm flex items-center gap-1">
            : <>{formatCurrencyVND(item?.sum_cost_price_min.toFixed(0))}</> -{' '}
            <>{formatCurrencyVND(item?.sum_cost_price_max.toFixed(0))}</>,{' '}
            {getCabinetCapital(item?.dong_hang) || 0} tủ:{' '}
            <>{item?.sum_order_min.toFixed(0)}</> -{' '}
            <>{item?.sum_order_max.toFixed(0)}</> sp
          </Col>
        </Row>
      );
    } else {
      const check = dataValidate?.filter((dataValidate) => {
        return dataValidate.code === item.dong_hang;
      });

      if (check?.length === 0) {
        return (
          <Row>
            <Col className="text-sm text-neutral-50" span={6}>
              {item?.dong_hang || '-'}
            </Col>
            <Col span={18} className="text-sm flex items-center gap-1">
              : <>{formatCurrencyVND(item?.sum_cost_price_min.toFixed(0))}</> -{' '}
              <>{formatCurrencyVND(item?.sum_cost_price_max.toFixed(0))}</>,{' '}
              {getCabinetCapital(item?.dong_hang) || 0} tủ:{' '}
              <>{item?.sum_order_min.toFixed(0)}</> -{' '}
              <>{item?.sum_order_max.toFixed(0)}</> sp <ValidateSuccess />
            </Col>
          </Row>
        );
      } else {
        return (
          <Row>
            <Col className="text-sm text-neutral-50" span={6}>
              {item?.dong_hang || '-'}
            </Col>
            <Col span={18} className="text-sm flex items-center gap-1">
              :{' '}
              {check.find((items: any) => {
                return items.type === 'price_min_dong_hang';
              }) === undefined ? (
                <>{formatCurrencyVND(item?.sum_cost_price_min.toFixed(0))}</>
              ) : (
                <>
                  <strong className="text-red-500">
                    {formatCurrencyVND(item?.sum_cost_price_min.toFixed(0))}{' '}
                  </strong>
                </>
              )}{' '}
              -{' '}
              {check.find((items: any) => {
                return items.type === 'price_max_dong_hang';
              }) === undefined ? (
                <>{formatCurrencyVND(item?.sum_cost_price_max.toFixed(0))}</>
              ) : (
                <>
                  <strong className="text-red-500">
                    {formatCurrencyVND(item?.sum_cost_price_max.toFixed(0))}{' '}
                  </strong>
                </>
              )}
              , {getCabinetCapital(item?.dong_hang) || 0} tủ:{' '}
              {check.find((items: any) => {
                return items.type === 'total_min_dong_hang';
              }) === undefined ? (
                <>{item?.sum_order_min.toFixed(0)}</>
              ) : (
                <>
                  <strong className="text-red-500">
                    {item?.sum_order_min.toFixed(0)}{' '}
                  </strong>
                </>
              )}{' '}
              -{' '}
              {check.find((items: any) => {
                return items.type === 'total_max_dong_hang';
              }) === undefined ? (
                <>{item?.sum_order_max.toFixed(0)}</>
              ) : (
                <>
                  <strong className="text-red-500">
                    {item?.sum_order_max.toFixed(0)}
                  </strong>
                </>
              )}{' '}
              sp
              <Popover
                content={
                  <div className="font-bold">
                    {check.map((items: any) => {
                      return (
                        <>
                          {items.message} <br />
                        </>
                      );
                    })}
                  </div>
                }
              >
                <ValidateFail />
              </Popover>
            </Col>
          </Row>
        );
      }
    }
  };
  const renderItemBottom = () => {
    return (
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="px-4">
        {(dataDongHang || []).map((item: any, index: any) => (
          <Col key={index} span={12} className="my-1">
            {renderValidateCapital(item)}
          </Col>
        ))}
      </Row>
    );
  };
  const getHHKN = () => {
    const data = dataProductPof?.filter((item: any) => {
      return item?.danh_muc === 'suggest';
    });
    return {
      minHHKN: (data || [])[0]?.price_min || 0,
      maxHHKN: (data || [])[0]?.price_max || 0,
    };
  };
  const renderTotalRegisterMin = () => {
    if (minRegister > getHHKN().minHHKN) {
      return (
        <Popover
          content={
            <div className="font-bold">
              Số tiền tối thiểu vượt quá số tiền khai báo ban đầu
            </div>
          }
        >
          <span className="font-bold text-red-500">
            {formatCurrencyVND(minRegister || (0).toFixed(0))}
          </span>{' '}
        </Popover>
      );
    } else {
      return (
        <span className="font-bold">
          {formatCurrencyVND(minRegister || (0).toFixed(0))}
        </span>
      );
    }
  };
  const renderTotalRegisterMax = () => {
    if (maxRegister > getHHKN().maxHHKN) {
      return (
        <Popover
          content={
            <div className="font-bold">
              Số tiền tối đa vượt quá số tiền khai báo ban đầu
            </div>
          }
        >
          <span className="font-bold text-red-500">
            {formatCurrencyVND(maxRegister || (0).toFixed(0))}
          </span>{' '}
        </Popover>
      );
    } else {
      return (
        <span className="font-bold">
          {formatCurrencyVND(maxRegister || (0).toFixed(0))}
        </span>
      );
    }
  };
  const capital_remain = {
    min: getHHKN().minHHKN - (capitalInfo?.data.capital_used_min || 0),
    max: getHHKN().maxHHKN - (capitalInfo?.data.capital_used_max || 0),
  };
  const items_left: CollapseProps['items'] = [
    {
      key: '1',
      label: <p className="text-xl font-bold">1. Vốn tồn đăng ký</p>,
      children: (
        <div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="start">
            <Col className="text-sm text-neutral-40" span={12}>
              Hàng hoá khuyến nghị
            </Col>
            <Col className="text-sm">
              : {formatCurrencyVND(getHHKN().minHHKN)} -{' '}
              {formatCurrencyVND(getHHKN().maxHHKN)}
            </Col>
          </Row>
          <Row
            className="mt-4"
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
          >
            <Col className="text-sm text-neutral-40" span={12}>
              Vốn tồn luỹ kế
            </Col>
            <Col className="text-sm">
              : {formatCurrencyVND(capitalInfo?.data.capital_used_min || 0)} -{' '}
              {formatCurrencyVND(capitalInfo?.data.capital_used_max || 0)}
            </Col>
          </Row>
          <Divider
            style={{
              borderStyle: 'dashed',
              borderWidth: '1px',
              borderColor: 'neutral-85',
            }}
          />
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="start">
            <Col className="text-sm font-bold text-neutral-40" span={12}>
              Vốn còn lại
            </Col>
            <Col className="text-sm">
              : {formatCurrencyVND(capital_remain.min || 0)} -{' '}
              {formatCurrencyVND(capital_remain.max || 0)}
            </Col>
          </Row>
        </div>
      ),
    },
  ];
  const items_right: CollapseProps['items'] = [
    {
      key: '1',
      label: <p className="text-xl font-bold">2. Đăng ký hiện tại</p>,
      children: (
        <div>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="start">
            <Col className="text-sm text-neutral-40" span={12}>
              Số lượng tủ trống đăng ký
            </Col>
            <Col className="text-sm">
              : {capitalInfo?.data.total_min_register || 0} -{' '}
              {capitalInfo?.data.total_max_register || 0} món
            </Col>
          </Row>
          <Row
            className="mt-4"
            gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            justify="start"
          >
            <Col className="text-sm text-neutral-40" span={12}>
              Số lượng món hiện tại
            </Col>
            <Col className="text-sm flex gap-1 items-center">
              :{' '}
              <span className="font-bold">
                {renderProductQuantityMin() || 0}
              </span>{' '}
              -
              <span className="font-bold">
                {renderProductQuantityMax() || 0}
              </span>{' '}
              món
            </Col>
          </Row>
          <Divider
            style={{
              borderStyle: 'dashed',
              borderWidth: '1px',
              borderColor: 'neutral-85',
            }}
          />
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="start">
            <Col className="text-sm font-bold text-neutral-40 " span={12}>
              Vốn tồn đăng ký hiện tại
            </Col>
            <Col className="text-sm">
              : {formatCurrencyVND(minRegister || 0)} -{' '}
              {formatCurrencyVND(maxRegister || 0)}
            </Col>
          </Row>
        </div>
      ),
    },
  ];
  const items_bottom: CollapseProps['items'] = [
    {
      key: '1',
      label: <p className="text-xl font-bold px-2">3. Vốn theo dòng hàng</p>,
      children: <div className="flex flex-col gap-2">{renderItemBottom()}</div>,
    },
  ];
  const columns: ColumnsType<any> = [
    {
      width: 999,
      align: 'left',
      render(index: any, record: any) {
        return (
          <div>
            <CartProductItem
              key={index}
              record={record}
              setCart_register_detail={showModal}
              setDataDelete={setDataDelete}
              setIsModalVisible={setIsModalVisible}
              setModalConfirmDelete={setModalConfirmDelete}
              ChangeValueMax={ChangeValueMax}
              ChangeValueMin={ChangeValueMin}
            />
            {renderValidateSet(record?.pro_code)}
          </div>
        );
      },
    },
    {
      width: 0.1,
      fixed: 'right' as FixedType,
    },
  ];
  const checkBeforeSendApprove = async () => {
    if (
      cartOrderCHT?.length == 0 ||
      cartOrderCHT[0].order_status === 1 ||
      cartOrderCHT[0].order_status === 2 ||
      cart_name[0].order_status === 4
    ) {
      openNotificationWithIcon(
        'error',
        'Không thế gửi phê duyệt đơn hàng',
        cartOrderCHT.length == 0
          ? 'Không có sản phẩm trong giỏ hàng'
          : 'Đơn hàng đã được ' + convertStatus(cartOrderCHT[0].order_status)
      );
    } else {
      setValidateLoading(true);

      await CartApi.checkValidateCHT(cartOrderCHT[0]?.cart_order_cht_id)
        .then((res) => {
          if (res.data === 'success') {
            setModalOpen(true);
          } else {
            setValidateLoading(false);

            const check = res.data?.find((item: any) => {
              return item?.isCritical === true;
            });

            if (check === undefined) {
              setModalOpen(true);
            } else {
              openNotificationWithIcon(
                'error',
                'Không đủ điều kiện đặt hàng',
                'Loại hàng đặt theo cặp, bộ'
              );
            }
          }
        })
        .catch((err) => {
          openNotificationWithIcon('error', 'Không thể gửi phê duyệt đơn hàng');
        })
        .finally(() => {
          setValidateLoading(false);
        });
    }
  };

  const checkStatusCHT = () => {
    if ((cartOrderCHT || []).length !== 0) {
      if (
        cartOrderCHT[0].order_status === 1 ||
        cartOrderCHT[0].order_status === 2 ||
        cartOrderCHT[0].order_status === 4
      ) {
        setDisableBtnCss('bg-gray-300');
      } else {
        setDisableBtnCss('bg-primary-50');
      }
    }
  };

  const hanlderGoBack = () => {
    history.goBack();
  };

  function generateExcel(dataExport: any) {
    const data = [];

    // create title
    const header = headerOrderReg.map((column) => {
      return column.title;
    });

    data.push(header);

    // create data
    dataExport.forEach((prm) => {
      const rowData = headerOrderReg.map((column) => {
        if (column.dataIndex == 'status') {
          const data =
            prm[column.dataIndex] == 0
              ? 'Mới tạo'
              : prm[column.dataIndex] == 1
              ? 'CHT Duyệt và gửi CN'
              : prm[column.dataIndex] == 2
              ? 'CN duyệt'
              : prm[column.dataIndex] == 3
              ? 'CN Từ chối'
              : prm[column.dataIndex] == 4
              ? 'HS Duyệt'
              : 'HS Từ Chối';
          return data;
        } else if (
          column.dataIndex == 'date_started' ||
          column.dataIndex == 'date_end' ||
          column.dataIndex == 'created_at' ||
          column.dataIndex == 'request_date'
        ) {
          const data = prm[column.dataIndex]
            ? prm[column.dataIndex].slice(0, 10)
            : '';
          return data;
        } else if (column.dataIndex == 'size') {
          if (prm[column.dataIndex] != undefined) {
            return prm[column.dataIndex]?.length != 0
              ? prm[column.dataIndex][0].value
              : '';
          }
        } else if (
          column.dataIndex == 'area_code' ||
          column.dataIndex == 'plant_code'
        ) {
          return prm[column.dataIndex]?.toString();
        } else if (
          !isNaN(prm[column.dataIndex]) &&
          !isNaN(parseFloat(prm[column.dataIndex]))
        )
          return Number(prm[column.dataIndex]);
        return prm[column.dataIndex] ? prm[column.dataIndex]?.toString() : '-';
      });
      data.push(rowData);
    });

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `Đơn hàng đăng ký.xlsx`);
  }
  const { mutate: exportMultiStore, isLoading: isExportLoading } = useMutation(
    CartApi.exportDonHangDangKy,
    {
      onSuccess: (data: any) => {
        if (data.status === 'success') {
          generateExcel(data?.data);
        } else {
          openNotificationWithIcon('success', 'Export thành công');
        }
      },
      onError: (error) => {
        console.log('er: ', error);
        openNotificationWithIcon('error', 'Export thất bại');
      },
    }
  );

  const handleExport = async () => {
    exportMultiStore({
      cart_code: cart_name[0]?.cart_code ?? state?.cart?.cart?.cart_code,
      isExportAsTVV: state?.isExportAsTVV ?? false,
      specific_plant_code:
        state?.cart?.order_shop?.ma_cua_hang ?? user?.plantCode,
    });
  };

  return (
    <Spin size="large" spinning={validateLoading}>
      <MainLayout
        isLoading={
          (getCartOrderCHT && capitalInfoLoading && getIdLoading) ||
          isExportLoading
        }
      >
        <Row
          justify="space-between"
          className="mb-5"
          gutter={{ xs: 2, sm: 4, md: 6, lg: 8 }}
        >
          <Col className="flex items-center">
            <div
              className="text-[#00538F] text-base font-medium cursor-pointer"
              onClick={() => hanlderGoBack()}
            >
              {'<'} Phê duyệt
            </div>
          </Col>
          <Row justify="end" gutter={{ xs: 2, sm: 4, md: 6, lg: 8 }}>
            <Button
              bgColor={'bg-white'}
              color={'text-primary-50'}
              border={'border-primary-50'}
              customClass="fix-border-radius"
              onClick={handleExport}
            >
              <DownloadOutlined />
              Tải file excel
            </Button>
            {!isRoleBranch && (
              <Col>
                <Button
                  onClick={() => {
                    setModalRejectOpen(true);
                  }}
                  customClass="items-center"
                  bgColor="bg-white"
                  color="text-red-500"
                  border="border-red-500"
                >
                  <CategoryCancel />
                  Từ chối
                </Button>
              </Col>
            )}
            {/* <Col>
              {' '}
              <Button
                bgColor="bg-white"
                color="text-primary-50"
                border="border-primary-50"
                onClick={() => {
                  CheckValidate(cartOrderCHT[0]?.cart_order_cht_id);
                }}
              >
                <AlertBlue />
                Check điều kiện
              </Button>
            </Col> */}
            <Col>
              <Button
                bgColor={'bg-white'}
                color={`${
                  isOpenFilter ? 'text-primary-50' : 'text-secondary-50'
                }`}
                border={`${
                  isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
                }`}
                onClick={toggleFilter}
              >
                {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
                Lọc
              </Button>
            </Col>
            {!isRoleBranch && (
              <Col>
                {user?.role.includes('cua_hang_truong') ? (
                  <Button
                    bgColor={disableBtnCss}
                    onClick={() => {
                      checkBeforeSendApprove();
                    }}
                  >
                    {' '}
                    <SendApproval /> Gửi phê duyệt
                  </Button>
                ) : (
                  <Button disabled={true} bgColor={disableBtnCss}>
                    {' '}
                    <SendApproval /> Gửi phê duyệt
                  </Button>
                )}
              </Col>
            )}
          </Row>
        </Row>

        <Row justify={'end'} style={{ marginTop: '20px' }}>
          <Tag color="blue">
            <strong
              style={{
                fontSize: '16px',
                paddingLeft: '10px',
                paddingRight: '10px',
              }}
            >
              {convertStatus(
                cartOrderCHT == undefined || cartOrderCHT?.length == 0
                  ? null
                  : cartOrderCHT[0].order_status
              )}
            </strong>
          </Tag>
        </Row>

        <Form
          form={form}
          layout="vertical"
          className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Content>
            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                <Form.Item name="ma_mau" label="Mã mẫu">
                  <Input placeholder="Nhập mã mẫu" className="" />
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="plhh" label="Phân loại hàng hóa">
                  <Select
                    size="middle"
                    placeholder="Chọn phân loại hàng hóa"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {plhh &&
                      plhh.map((item: any) => (
                        <Option key={item.plhh} value={item.plhh}>
                          {item.plhh}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="" span={6}>
                <Form.Item name="line_xman" label="Dòng hàng Xman">
                  <Select
                    size="middle"
                    placeholder="Chọn dòng hàng"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {donghang &&
                      donghang.map((item: any) => (
                        <Option
                          key={item.line_xman_text}
                          value={item.line_xman_text}
                        >
                          {item.line_xman_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col className="" span={6}>
                <Form.Item name="nganh_hang" label="Ngành hàng">
                  <Select
                    size="middle"
                    placeholder="Chọn ngành hàng"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {nganhhang &&
                      nganhhang.map((item: any) => (
                        <Option key={item.prod_grp2} value={item.prod_grp2}>
                          {item.prod_grp2_name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="" span={6}>
                <Form.Item name="chung_loai" label="Chủng loại SAP">
                  <Select
                    size="middle"
                    placeholder="Chọn chủng loại"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {chungloai &&
                      chungloai.map((item: any) => (
                        <Option key={item.chungloai} value={item.chungloai}>
                          {item.chungloai + ' - ' + item.chungloai_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="kldg_3tc" label="Đánh giá TQ">
                  <Select
                    size="middle"
                    placeholder="Chọn đánh giá TQ"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {kldg_3tc &&
                      kldg_3tc.map((item: any) => (
                        <Option key={item.kldg_3tc} value={item.kldg_3tc}>
                          {item.kldg_3tc}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="cost_price" label="Giá vốn bình quân">
                  {costprice && (
                    <Slider
                      min={costprice?.min}
                      max={costprice?.max}
                      range
                      step={10}
                      tooltip={{
                        formatter: (value: any) => {
                          return formatCurrencyVND(value);
                        },
                      }}
                      defaultValue={[costprice?.min, costprice?.max]}
                    />
                  )}
                </Form.Item>
              </Col>
              {/* <Col className="" span={6}>
                    <Form.Item name="price" label="Giá bán">
                      {price && (
                        <Slider
                          min={price?.min}
                          max={price?.max}
                          range
                          step={10}
                          tooltip={{
                            formatter: (value: any) => {
                              return formatCurrencyVND(value);
                            },
                          }}
                          defaultValue={[price?.min, price?.max]}
                        />
                      )}
                    </Form.Item>
                  </Col> */}
            </Row>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
              <Col className="flex justify-end" span={24}>
                <Button
                  bgColor={'bg-white'}
                  color={'text-primary-50'}
                  border={'border-white'}
                  onClick={toggleFilterAdvanced}
                >
                  Tìm kiếm nâng cao
                  {isOpenFilterAdvanced ? <UpOutlined /> : <DownOutlined />}
                </Button>
              </Col>
            </Row>

            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              className={`items-center ${
                isOpenFilterAdvanced ? '' : 'hidden'
              } mt-4`}
            >
              <Col className="" span={6}>
                <Form.Item name="loai_da" label="Loại đá">
                  <Select
                    size="middle"
                    placeholder="Chọn loại đá"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {loaida &&
                      loaida.map((item: any) => (
                        <Option key={item.loai_da} value={item.loai_da}>
                          {item.loai_da}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="nhom_da" label="Nhóm đá">
                  <Select
                    size="middle"
                    placeholder="Chọn nhóm đá"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {nhomda &&
                      nhomda.map((item: any) => (
                        <Option key={item.nhom_da} value={item.nhom_da}>
                          {item.nhom_da}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              {/* <Col className="" span={6}>
                    <Form.Item name="email" label="BST">
                      <Select placeholder={'Chọn BST'} size="middle" />
                    </Form.Item>
                  </Col> */}

              <Col className="" span={6}>
                <Form.Item name="dong_hang" label="Dòng hàng SAP">
                  <Select
                    size="middle"
                    placeholder="Nhập dòng hàng SAP"
                    allowClear
                    mode="multiple"
                    maxTagCount="responsive"
                  >
                    {donghangsap &&
                      donghangsap.map((item: any) => (
                        <Option key={item.prod_grp4} value={item.prod_grp4}>
                          {item.prod_grp4_name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="zma_bo" label="Bộ">
                  <Select size="middle" placeholder="Chọn bộ" allowClear>
                    {bo &&
                      bo.map((item: any) => (
                        <Option key={item.zma_bo} value={item.zma_bo}>
                          {item.zma_bo_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
              className={`items-center ${
                isOpenFilterAdvanced ? '' : 'hidden'
              } mt-4`}
            >
              <Col className="" span={6}>
                <Form.Item name="zma_ts_cap" label="Cặp">
                  <Select size="middle" placeholder="Nhập cặp" allowClear>
                    {cap &&
                      cap.map((item: any) => (
                        <Option key={item.zma_ts_cap} value={item.zma_ts_cap}>
                          {item.zma_ts_cap_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="gioi_tinh" label="Giới tính">
                  <Select
                    size="middle"
                    placeholder="Chọn giới tính"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {gioitinh &&
                      gioitinh.map((item: any) => (
                        <Option key={item.gioitinh} value={item.gioitinh}>
                          {item.gioitinh_text}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="material_type" label="Material Type">
                  <Select
                    size="middle"
                    placeholder="Chọn Material Type"
                    mode="multiple"
                    maxTagCount="responsive"
                    allowClear
                  >
                    {materialtype &&
                      materialtype.map((item: any) => (
                        <Option
                          key={item.material_type}
                          value={item.material_type}
                        >
                          {item.material_type}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col className="" span={6}>
                <Form.Item name="xman" label="Xman">
                  <Select size="middle" placeholder="Chọn Xman" allowClear>
                    {xman &&
                      xman.map((item: any) => (
                        <Option key={item.xman} value={item.xman}>
                          {item.xman}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} justify="end">
              <Col className="flex justify-end mt-4" span={8}>
                <Space>
                  <Button
                    bgColor={'bg-white'}
                    color={'text-primary-50'}
                    border={'border-primary-50'}
                    onClick={handleReset}
                  >
                    Hủy
                  </Button>
                  <Button type="submit">Tìm kiếm</Button>
                </Space>
              </Col>
            </Row>
          </Content>
        </Form>

        {/* <Row className="my-5" justify="center">
          <Col span={12} className="pr-2">
            <Collapse
              className="bg-white"
              expandIconPosition="right"
              ghost
              expandIcon={({ isActive }) => (
                <DownOutlined rotate={isActive ? 180 : 0} />
              )}
              size="small"
              items={items_left}
            />
          </Col>
          <Col span={12} className="pl-2">
            <Collapse
              className="bg-white"
              expandIconPosition="right"
              ghost
              expandIcon={({ isActive }) => (
                <DownOutlined rotate={isActive ? 180 : 0} />
              )}
              size="small"
              items={items_right}
            />
          </Col>
        </Row>

        <Row className="my-5" justify="center">
          <Col span={24} className="bg-white">
            <Collapse
              expandIconPosition="right"
              ghost
              expandIcon={({ isActive }) => (
                <DownOutlined rotate={isActive ? 180 : 0} />
              )}
              size="small"
              items={items_bottom}
            />
          </Col>
        </Row> */}

        {/* popup yêu cầu phê duyệt */}
        <Modal
          open={modalOpen}
          onCancel={() => {
            setModalOpen(false);
          }}
          footer={null}
          width={'50%'}
        >
          <Content className="w-full">
            <p className="text-2xl font-bold">Gửi yêu cầu phê duyệt giỏ hàng</p>
            <Divider style={{ margin: '20px 0' }} />
            <div>
              <p className="text-base">
                Bạn có chắc muốn gửi yêu cầu phê duyệt giỏ hàng lên cung ứng chi
                nhánh?
                <br />
                <span className="text-red-500 font-medium">
                  Lưu ý: khi đơn hàng gửi lên chi nhánh, bạn không thể đặt thêm
                  hàng.
                </span>
              </p>
            </div>
            <Row justify="end" className="mt-4">
              <Button
                onClick={() => {
                  setModalOpen(false);
                }}
                customClass="text-neutral-50 mr-2"
                bgColor="white"
              >
                Huỷ
              </Button>
              <Button onClick={requestApprovalToBranch}>Gửi yêu cầu</Button>
            </Row>
          </Content>
        </Modal>

        {/* popup xoá hàng loạt sản phẩm */}
        <Modal
          open={modalConfirmDelALL}
          onCancel={() => {
            setModalConfirmDelALL(false);
          }}
          footer={null}
          width={'50%'}
        >
          <Content className="w-full">
            <p className="text-2xl font-bold">
              Xác nhận xoá hàng loạt sản phẩm
            </p>
            <Divider style={{ margin: '20px 0' }} />
            <div>
              <p className="text-base">
                Bạn có chắc muốn xoá hàng loạt sản phẩm trong giỏ hàng?
              </p>
            </div>
            <Row justify="end" className="mt-4">
              <Button
                onClick={() => {
                  setModalConfirmDelALL(false);
                }}
                customClass="text-neutral-50 mr-2"
                bgColor="white"
              >
                Huỷ
              </Button>
              <Button
                onClick={() => {
                  deleteAll();
                  setModalConfirmDelALL(false);
                }}
              >
                Xoá
              </Button>
            </Row>
          </Content>
        </Modal>

        {/* popup xoá 1 sản phẩm */}
        <Modal
          open={modalConfirmDelete}
          onCancel={() => {
            setModalConfirmDelete(false);
          }}
          footer={null}
          width={'50%'}
        >
          <Content className="w-full">
            <p className="text-2xl font-bold">Xác nhận xoá sản phẩm</p>
            <Divider style={{ margin: '20px 0' }} />
            <div>
              <p className="text-base">Bạn có chắc muốn xoá sản phẩm này?</p>
            </div>
            <Row justify="end" className="mt-4">
              <Button
                onClick={() => {
                  setModalConfirmDelete(false);
                }}
                customClass="text-neutral-50 mr-2"
                bgColor="white"
              >
                Huỷ
              </Button>
              <Button
                onClick={() => {
                  setModalConfirmDelete(false);
                  deleteProdctCHT(
                    cart_order_cht_id || 0,
                    list_cart_order_cht_dt_ids || [],
                    false
                  );
                }}
              >
                Xoá
              </Button>
            </Row>
          </Content>
        </Modal>

        {/* popup từ chối phê duyệt */}
        <Modal
          open={modalRejectOpen}
          onCancel={() => {
            setModalRejectOpen(false);
          }}
          footer={null}
          width={'50%'}
        >
          <Content className="w-full">
            <p className="text-2xl font-bold pb-6 border-b-2 border-neutral-90">
              Từ chối phê duyệt
            </p>
            <div className="py-6">
              <Form layout="vertical" onSubmitCapture={formik.handleSubmit}>
                <Form.Item label="Tên tư vấn viên">
                  <Select
                    onChange={handleChangeSelect('cart_order_tvv_id')}
                    placeholder="Chọn nhân viên"
                  >
                    {TvvReject?.map((item, index) => {
                      return (
                        <Select.Option
                          key={index}
                          value={item.cart_ordert_tvv_id}
                        >
                          {item.full_name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item label="Lý do">
                  <TextArea
                    onChange={formik.handleChange}
                    name="reject_description"
                    showCount
                    maxLength={100}
                    placeholder="Nhập lý do"
                  />
                </Form.Item>

                <Row justify="end">
                  <Button
                    onClick={() => {
                      setModalRejectOpen(false);
                    }}
                    customClass="text-neutral-50 mr-2"
                    bgColor="white"
                  >
                    Huỷ
                  </Button>
                  <Button type="submit">Xác nhận</Button>
                </Row>
              </Form>
            </div>
          </Content>
        </Modal>

        <Modal
          open={modalConfirmReject}
          footer={null}
          onCancel={() => {
            setModalConfirmReject(false);
          }}
          width={'40%'}
        >
          <Result
            status="success"
            title="Từ chối phê duyệt thành công"
            subTitle={
              <div>
                `Đơn hàng của{' '}
                <span className="font-bold">{nameTVVrejected}</span> đã loại
                khỏi đơn hàng của cửa hàng.`
              </div>
            }
            extra={
              <Row justify="center">
                <Button onClick={() => setModalConfirmReject(false)}>
                  Đóng
                </Button>
              </Row>
            }
          />
        </Modal>

        {/* popup xem thông tin sản phẩm */}
        <Modal
          title={
            <span className="custom-modal-header">Thông tin sản phẩm</span>
          }
          visible={isModalVisible}
          width={'70%'}
          closeIcon={<CloseOutlined onClick={handleCancel} />}
          style={{ marginTop: '-75px' }}
          footer={null}
        >
          <Divider
            style={{
              borderTop: '1px solid rgba(0, 0, 0, 0.2)',
              marginTop: '8px',
              marginBottom: '0px',
            }}
          />
          <ProductCartInfo
            ref={modalRef}
            data={cart_register_detail}
            setMin={modalData?.ChangeValueMin}
            setMax={modalData?.ChangeValueMax}
          />
          <div
            className="flex justify-end"
            style={{
              backgroundColor: '#EFF3F8',
              padding: '16px 36px',
              margin: '-20px -24px',
            }}
          >
            <Button customClass="end" onClick={handleCancel}>
              Đóng lại
            </Button>
          </div>
        </Modal>

        <Content className="main-content mt-5">
          <Row align="middle" className="bg-neutral-95 rounded p-5">
            <Col span={8}>
              <p className="text-base font-bold">
                Tổng: <span className="text-primary-50">{total}</span> <br />
                SL Min:{' '}
                <span className="text-primary-50">{minQuantity || 0}</span> món
                SL Max:{' '}
                <span className="text-primary-50">{maxQuantity || 0}</span> món
              </p>
            </Col>
            <Col span={16}>
              <div className="w-full text-right">
                <p className="text-base">
                  Đăng kí MIN: {renderTotalRegisterMin() || 0}- MAX:{' '}
                  {renderTotalRegisterMax() || 0}
                </p>
              </div>
            </Col>
          </Row>
          {/* {user?.role.includes('cua_hang_truong') &&
            cartOrderCHT != undefined &&
            cartOrderCHT?.length != 0 &&
            cartOrderCHT[0].order_status != 2 &&
            cartOrderCHT[0].order_status != 4 && (
              <Row className="mt-3" justify={'end'} align={'middle'}>
                <Col>
                  <Button
                    bgColor="bg-white"
                    color="text-primary-50"
                    border="border-white"
                    onClick={() => {
                      setModalConfirmDelALL(true);
                    }}
                  >
                    Xoá tất cả
                  </Button>
                </Col>
              </Row>
            )} */}

          <Table
            rowKey={(record) => record.cart_order_cht_dt_id}
            columns={columns}
            className="customTable mt-3"
            loading={getCartOrderCHT}
            dataSource={cartOrderCHT}
            scroll={{ x: 958 }}
            rowClassName={(record: any) => {
              if ((checkSetValidate(record?.pro_code) || []).length > 0) {
                return 'ant-ActiveRow';
              } else {
                return '';
              }
            }}
            pagination={{
              className: 'flex items-center',
              current: page,
              pageSize: page_size,
              total: total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '50'],
              onChange: HocChangePagination(history),
            }}
          />
        </Content>
      </MainLayout>
    </Spin>
  );
}
